import React from "react";
import { RangeFilter } from "../Ranges/RangeFilter";
import { FilterRange } from "../Ranges/types";

interface VendorInstallsCountFilterProps {
  value?: FilterRange;
  onChange: (value: FilterRange) => void;
  isDisabled?: boolean;
}

/**
 * Filter component for refining by number of installations from vendors
 * Uses "No limit" placeholder when no values are defined
 */
export const VendorInstallsCountFilter: React.FC<VendorInstallsCountFilterProps> =
  React.memo(({ value, onChange, isDisabled = false }) => {
    const handleRangeChange = (
      min: number | undefined,
      max: number | undefined
    ) => {
      onChange({
        min: min ?? undefined,
        max: max ?? undefined,
      });
    };

    return (
      <RangeFilter
        value={value || { min: undefined, max: undefined }}
        onChange={handleRangeChange}
        minLabel="Minimum Installs"
        maxLabel="Maximum Installs"
        minPlaceholder="No limit"
        maxPlaceholder="No limit"
        isDisabled={isDisabled}
        thousandSeparator={true}
        updatedOnType={false}
      />
    );
  });
